import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import TimestampManager from '../../utils/TimestampManager';
import DynamicAction from '../../utils/DynamicAction';
import { DynamicActionKey } from '../../utils/DynamicAction/DynamicAction';
import PanelType from './types';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { FAVOURITE_ONBOARDING_STEPS as MOBILE_FAVOURITE_ONBOARDING_STEPS } from '../../../mobile/components/OnboardingLayer/onboardingSteps';
import { FAVOURITE_ONBOARDING_STEPS as WEB_FAVOURITE_ONBOARDING_STEPS } from '../../../web/src/components/OnboardingLayer/onboardingSteps';
import audio from '../../utils/audio';
import store from '../../state/store';
import { setGameProvider } from '../../state/actions/game';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import useProgressiveJackpots from '../../hooks/useProgressiveJackpots';
import { FE_PROGRESSIVE_JACKPOTS, FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import { BOOLEANS, PLATFORM } from '../../constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import utils from '../../utils';
import NotificationContext from '../../context/NotificationContext';
import ERROR_CODE from '../../utils/errorCodes/index.js';

/** @typedef {import('../../api/Constants').LivePanelInfo} LivePanelInfo */
/** @typedef {import('../../api/Constants').LobbyItemsInfo} LobbyItemsInfo */
/** @typedef {import('../../api/Constants').MobileUrls} MobileUrls */
var GameTile = /*#__PURE__*/function (_Component) {
  function GameTile(props) {
    var _this;
    _classCallCheck(this, GameTile);
    _this = _callSuper(this, GameTile, [props]);
    _this.timer = null;
    _this.initExpireTimer = function () {
      /** @type {LivePanelInfo} */
      var itemData = _this.props.itemData;
      if (itemData.seconds_until_expiry) {
        _this.timer = TimestampManager.register(itemData.seconds_until_expiry * 1000, _this._expireHandler);
      }
    };
    _this.isInFavouriteGameList = function () {
      var itemId = _this.props.itemData.item_id;
      var favgames = _this.props.favouriteGames.gameList;
      if (favgames.length == 0) {
        _this.setState({
          isFavourite: false
        });
      } else {
        for (var game in favgames) {
          if (game) {
            if (favgames[game].game_id == "".concat(itemId)) {
              _this.setState({
                isFavourite: true
              });
              return;
            }
            _this.setState({
              isFavourite: false
            });
          }
        }
      }
    };
    _this._expireHandler = function () {
      _this.setState({
        expired: true
      });
    };
    _this._showModal = function (modalType, itemData) {
      QueryParamsProxy.setQueryParams(_objectSpread(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType), itemData ? _defineProperty({}, RouteParamConstants.PARAM_FAVOURITE_GAME_ID, itemData.item_id) : {}));
    };
    _this._addFavouriteGame = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var item_id, favgames, game, newFavGame, _this$props, onboardingStep, setOnboardingStep, setFavouriteGames, addFavouriteGame, addFavouriteResponse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              audio.onClick();
              if (_this.userCanFavourite()) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", false);
            case 3:
              event.stopPropagation();
              item_id = _this.props.itemData.item_id;
              if (item_id) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              favgames = _this.props.favouriteGames.gameList;
              _context.t0 = _regeneratorRuntime().keys(favgames);
            case 9:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 15;
                break;
              }
              game = _context.t1.value;
              if (!(favgames[game].game_id == "".concat(item_id))) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return");
            case 13:
              _context.next = 9;
              break;
            case 15:
              newFavGame = {};
              newFavGame.game_id = "".concat(item_id);
              newFavGame.game_name = '';
              _context.prev = 18;
              _this$props = _this.props, onboardingStep = _this$props.onboardingStep, setOnboardingStep = _this$props.setOnboardingStep, setFavouriteGames = _this$props.setFavouriteGames, addFavouriteGame = _this$props.addFavouriteGame;
              _context.next = 22;
              return addFavouriteGame(item_id);
            case 22:
              addFavouriteResponse = _context.sent;
              _this.setState({
                isFavourite: true
              });
              favgames.push(newFavGame);
              setFavouriteGames(favgames);
              if (utils.getPlatform() === PLATFORM.WEB) {
                if (onboardingStep === WEB_FAVOURITE_ONBOARDING_STEPS.PICK_FAVOURITE) {
                  setOnboardingStep(WEB_FAVOURITE_ONBOARDING_STEPS.GO_TO_FAVOURITES);
                  Logger.sendEvent(EVENT_TYPES.TUTORIAL_STEP_COMPLETE, {
                    id: ONBOARDING_FLOWS.FAVOURITES,
                    step: 2
                  });
                }
              } else if (onboardingStep === MOBILE_FAVOURITE_ONBOARDING_STEPS.PICK_FAVOURITE) {
                setOnboardingStep(MOBILE_FAVOURITE_ONBOARDING_STEPS.OPEN_MENU);
                Logger.sendEvent(EVENT_TYPES.TUTORIAL_STEP_COMPLETE, {
                  id: ONBOARDING_FLOWS.FAVOURITES,
                  step: 2
                });
              }
              return _context.abrupt("return", addFavouriteResponse);
            case 30:
              _context.prev = 30;
              _context.t2 = _context["catch"](18);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t2),
                code: ERROR_CODE.ADD_FAVOURITE_GAME_ERROR_CODE
              });
              _this.context.addNotification({
                message: getText(TEXT_KEY.ADD_FAVOURITE_ERROR),
                title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                button: getText(TEXT_KEY.OK)
              });
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[18, 30]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this._removeFavouriteGameConfirmation = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var _this$props2, itemData, setFavouriteGames, favouriteGames, removeFavouriteGame, itemId, favgames, updatedFavGames, removeFavouriteResponse;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              audio.onClick();
              if (_this.userCanFavourite()) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", false);
            case 3:
              event.stopPropagation();
              _this$props2 = _this.props, itemData = _this$props2.itemData, setFavouriteGames = _this$props2.setFavouriteGames, favouriteGames = _this$props2.favouriteGames, removeFavouriteGame = _this$props2.removeFavouriteGame;
              itemId = itemData.item_id;
              favgames = favouriteGames.gameList;
              updatedFavGames = favgames.filter(function (game) {
                return game.game_id !== "".concat(itemId);
              });
              _context2.prev = 8;
              _context2.next = 11;
              return removeFavouriteGame(itemId);
            case 11:
              removeFavouriteResponse = _context2.sent;
              setFavouriteGames(updatedFavGames);
              return _context2.abrupt("return", removeFavouriteResponse);
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](8);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context2.t0),
                code: ERROR_CODE.REMOVE_FAVOURITE_GAME_ERROR_CODE
              });
              _this.context.addNotification({
                message: getText(TEXT_KEY.REMOVE_FAVOURITE_ERROR),
                title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                button: getText(TEXT_KEY.OK)
              });
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[8, 16]]);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    _this._clickHandler = function (trigger) {
      audio.onClick();
      var _this$props3 = _this.props,
        clickHandler = _this$props3.clickHandler,
        itemData = _this$props3.itemData,
        navigation = _this$props3.navigation;
      store.dispatch(setGameProvider(itemData.PROVIDER));
      if (clickHandler) {
        clickHandler(itemData);
      }

      /** @type {LivePanelInfo} */
      itemData.item_id = itemData.GAME_ID;
      itemData.item_type = PanelType.GAMES;
      if (!itemData.item_id && !itemData.id) {
        return;
      }
      switch (itemData.item_type) {
        case PanelType.GAMES:
        case PanelType.FEATURED_GAMES:
        case PanelType.NEW_GAMES:
          if (itemData.SNEAK_PEEK_END_DATE) {
            DynamicAction.getActionCallback("sneakPeek:".concat(itemData.GAME_ID, ",").concat(itemData.SNEAK_PEEK_END_DATE), navigation)();
          } else {
            DynamicAction.getActionCallback("".concat(DynamicActionKey.LAUNCH_GAME, ":").concat(itemData.item_id, ":").concat(trigger), navigation)();
          }
          break;
        case PanelType.NEWS:
        case PanelType.EVENTS:
        case PanelType.SALES:
        default:
          _this.context.addNotification({
            message: getText(TEXT_KEY.PANEL_NOT_SUPPORTED_ERROR),
            title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
            button: getText(TEXT_KEY.OK)
          });
          break;
      }
    };
    _this.userCanFavourite = function () {
      var _this$props4 = _this.props,
        itemData = _this$props4.itemData,
        userCanFavourite = _this$props4.userCanFavourite;
      if (itemData.item_type == 'featured-game' || itemData.item_type == 'new-game' || !itemData.item_id) {
        return false;
      }
      return userCanFavourite;
    };
    _this.changeFtueStep = function (step) {
      _this.props.setOnboardingFtueStep(step);
    };
    _this.openFtueOnboarding = function (message, position) {
      _this.props.setOnboardingHighlightedPosition(position, message);
    };
    _this.state = {
      expired: false,
      isFavourite: false
    };
    return _this;
  }
  _inherits(GameTile, _Component);
  return _createClass(GameTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initExpireTimer();
      this.isInFavouriteGameList();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
        favouriteGames = _this$props5.favouriteGames,
        itemData = _this$props5.itemData;
      var prevFavouriteGames = prevProps.favouriteGames;
      if (favouriteGames.gameList && prevFavouriteGames && favouriteGames.gameList.length != prevFavouriteGames.gameList.length || itemData.item_id !== prevProps.itemData.item_id) {
        this.isInFavouriteGameList();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        TimestampManager.unregister(this.timer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      /** @type {LivePanelInfo} */
      var _this$props6 = this.props,
        itemData = _this$props6.itemData,
        render = _this$props6.render,
        ftueStep = _this$props6.ftueStep;
      var _useFeatureFlags = useFeatureFlags(),
        hasFeature = _useFeatureFlags.hasFeature;
      var _useProgressiveJackpo = useProgressiveJackpots(),
        getProgressiveJackpotsData = _useProgressiveJackpo.getProgressiveJackpotsData;
      var sneakPeekTimer = hasFeature(FE_SNEAK_PEEK) && (itemData === null || itemData === void 0 ? void 0 : itemData.SNEAK_PEEK_END_DATE);
      var progressiveJackpotsData = hasFeature(FE_PROGRESSIVE_JACKPOTS) && itemData.HAS_PROGRESSIVE_JACKPOTS && getProgressiveJackpotsData(itemData.GAME_ID);
      var _this$state = this.state,
        expired = _this$state.expired,
        isFavourite = _this$state.isFavourite;
      return render({
        cacheId: this.props.cacheId,
        data: itemData,
        expired: expired,
        clickHandle: this._clickHandler,
        isFavourite: isFavourite,
        addFavouriteGame: this._addFavouriteGame,
        removeFavouriteGame: this._removeFavouriteGameConfirmation,
        userCanFavourite: this.userCanFavourite(),
        locked: itemData.UNLOCKED !== BOOLEANS.TRUE,
        openFtueOnboarding: this.openFtueOnboarding,
        changeFtueStep: this.changeFtueStep,
        ftueStep: ftueStep,
        sneakPeekTimer: sneakPeekTimer,
        progressiveJackpotsData: progressiveJackpotsData
      });
    }
  }]);
}(Component);
GameTile.contextType = NotificationContext;
export { GameTile as default };